/**
 * Returns the formatted date
 * @param utcString - A string with a date that needs to be formatted
 * @param options - toLocaleDateString options
 *
 * @see https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
 *
 * @example
 * getLocalDateStringFromUTC(`1992-06-22`); // Will return `понедельник, 22 июня 1992 г.`
 */
export const getLocalDateStringFromUTC = (utcString: string, options?: Intl.DateTimeFormatOptions): string =>
	new Date(utcString).toLocaleDateString(`ru-RU`, {
		weekday: `long`,
		year: `numeric`,
		month: `long`,
		day: `numeric`,
		...options
	})
